import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ArrowUpRight, ArrowDown } from "lucide-react";

export default function About() {
  return (
    <div className="min-h-screen bg-void">
      <Navbar />

      <section className="relative overflow-hidden border-b border-edge">
        <div className="absolute inset-0 grid-bg opacity-60" />
        <div className="relative mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
          <span className="font-mono text-xs font-semibold uppercase tracking-widest text-yellow">About GradeTrack</span>
          <h1 className="mt-5 max-w-3xl font-head text-5xl font-black uppercase leading-[0.92] tracking-tight text-gray-100 lg:text-7xl">
            Built from<br />the field.
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-gray-400">
            GradeTrack is a sister product to CrewTrack, built to connect the construction plans in the
            office with the ground beneath your machine.
          </p>
        </div>
      </section>

      <section className="dot-bg py-20 lg:py-24">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <p className="text-lg leading-relaxed text-gray-300">
            GradeTrack was created with the same philosophy behind CrewTrack: construction software
            should be practical, straightforward, and built around how crews actually work.
          </p>
          <p className="mt-6 text-lg leading-relaxed text-gray-400">
            CrewTrack helps companies manage their crews, equipment, time, labor, production and job
            costing. GradeTrack helps operators and foremen visualize their plans, position those plans
            over the real world, and understand where they are on the site.
          </p>
          <p className="mt-8 font-head text-2xl font-bold uppercase tracking-tight text-gray-100">
            Different tools.<br /><span className="text-yellow">Same construction-first philosophy.</span>
          </p>
        </div>
      </section>

      {/* ECOSYSTEM */}
      <section className="border-y border-edge bg-void py-20 lg:py-28">
        <div className="mx-auto max-w-5xl px-5 lg:px-8">
          <h2 className="text-center font-head text-2xl font-extrabold uppercase tracking-tight text-gray-100 lg:text-3xl">
            The CrewTrack + GradeTrack ecosystem
          </h2>
          <div className="mt-14 flex flex-col items-center gap-6">
            <div className="w-full max-w-xl border border-edge bg-cardbg p-7 text-center">
              <div className="font-head text-3xl font-bold uppercase tracking-tighter">
                <span className="text-gray-100">CREW</span><span className="text-crew">TRACK</span>
              </div>
              <p className="mt-2 font-mono text-xs uppercase tracking-widest text-gray-500">
                People • Equipment • Time • Labor • Production
              </p>
            </div>

            <ArrowDown className="h-7 w-7 text-yellow" />

            <div className="w-full max-w-xl border-2 border-yellow bg-cardbg p-7 text-center">
              <div className="font-head text-3xl font-bold uppercase tracking-tighter">
                <span className="text-gray-100">GRADE</span><span className="text-yellow">TRACK</span>
              </div>
              <p className="mt-2 font-mono text-xs uppercase tracking-widest text-gray-500">
                Plans • Maps • Position • Site Progress
              </p>
            </div>

            <div className="mt-4 font-head text-xl font-bold uppercase tracking-[0.3em] text-gray-300">
              Field <span className="text-yellow">→</span> Office
            </div>
          </div>
        </div>
      </section>

      <section className="bg-panel py-16">
        <div className="mx-auto max-w-3xl px-5 text-center lg:px-8">
          <p className="text-gray-400">
            Together, they connect what is happening <span className="text-gray-100">on the site</span> with what
            is being managed <span className="text-gray-100">in the office</span>.
          </p>
          <a href="https://crewtrack.team" target="_blank" rel="noopener noreferrer" data-testid="about-crewtrack-link"
            className="mt-8 inline-flex items-center gap-2 border border-crew px-7 py-3.5 font-head text-sm font-bold uppercase tracking-wider text-crew transition-colors hover:bg-crew hover:text-black">
            Explore CrewTrack <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
